'use client'

import { Spacer } from '@vinted/web-ui'

import { ReferralsBanner } from '@marketplace-web/banners/banners-feature'
import { ProfileTaxpayerBanner } from '@marketplace-web/taxpayers/taxpayers-feature'

import { ProfileBadges } from '@marketplace-web/seller-engagement-tools/seller-engagement-tools-feature'
import { ProfileVasBanners } from '@marketplace-web/vas/vas-feature'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

type Props = {
  renderCountDownBanner: () => JSX.Element | null
}

const ProfileOwnerBanners = ({ renderCountDownBanner }: Props) => {
  const breakpoints = useBreakpoint()

  const profileReworkAbTest = useAbTest('profile_wardrobe_web_rework')
  const isProfileReworkTestOn = profileReworkAbTest?.variant === 'on' && !breakpoints.portables

  return (
    <>
      {(!isProfileReworkTestOn || breakpoints.phones) && <ProfileTaxpayerBanner />}
      <ReferralsBanner
        bottomSpacer={breakpoints.tabletsUp && <Spacer size={Spacer.Size.Large} />}
      />
      {renderCountDownBanner()}
      <ProfileVasBanners />
      {(!isProfileReworkTestOn || breakpoints.phones) && <ProfileBadges />}
    </>
  )
}

export default ProfileOwnerBanners
